module.exports = __webpack_public_path__ + "81ddaf3373e31a87b5513e71ae05562e.jpg";